export default {
  rankJoin: '/honour/client/rankJoin'
}
